module.exports = __webpack_public_path__ + "img/Magnuss04.61282217.jpg";